import initDatadogRum from "../utils/initDatadogRum";

// /companies 系の Sprockets レイアウトでも RUM を動かすための最小 pack
initDatadogRum();
